module.exports = __webpack_public_path__ + "img/metaMaskInstallationStep_14_mobile.29968e0.png";